// src/lib/useEmailHint.js
// Hook voor het "Bedoelt u …?"-regeltje onder een e-mailveld. Niet-blokkerend.
// Events dragen alleen het domein, nooit het adres.
import { useRef, useState } from 'react';
import { emailSuggestion, domainOf } from './emailSuggest';
import { trackEvent } from './analytics';

/**
 * @param {string} value                  huidige veldwaarde
 * @param {(v: string) => void} setValue  zet de veldwaarde via state
 */
export function useEmailHint(value, setValue) {
  const [suggestion, setSuggestion] = useState('');
  const lastShown = useRef('');

  const onBlur = () => {
    const s = emailSuggestion(value);
    setSuggestion(s);
    if (s && s !== lastShown.current) trackEvent('email_suggestie_getoond', { domain: domainOf(s) });
    lastShown.current = s;
  };
  const hide = () => setSuggestion('');
  const apply = () => {
    if (!suggestion) return;
    setValue(suggestion);
    trackEvent('email_suggestie_overgenomen', { domain: domainOf(suggestion) });
    lastShown.current = '';
    setSuggestion('');
  };
  return { suggestion, onBlur, hide, apply };
}
